import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import { PaginatedPurchaseProcesses } from '@Purchasing/Data/DataSource/API/Entity/PurchaseProcess'
import { PurchaseProcessStatus } from '@Purchasing/Domain/Model/PurchaseProcess'
import { useCallback, useEffect, useRef, useState } from 'react'

export const usePurchaseProcesses = (
    page = 1,
    limit = 10,
    search = '',
    status?: PurchaseProcessStatus,
    /** Ids de responsáveis separados por vírgula ("none" = sem responsável). */
    assignedTo?: string
) => {
    const useCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseGetPurchaseProcesses
    )
    const [data, setData] = useState<PaginatedPurchaseProcesses>({
        items: [],
        total: 0,
        page,
        limit,
    })
    const [loading, setLoading] = useState<boolean>(false)
    // Só a resposta da busca mais recente atualiza a lista.
    const requestRef = useRef(0)

    const load = useCallback(async () => {
        const request = ++requestRef.current
        setLoading(true)
        try {
            const result = await useCase.execute({
                page,
                limit,
                search,
                status,
                assignedTo: assignedTo || undefined,
            })
            if (request !== requestRef.current) return
            setData(result)
        } catch (e) {
            console.error(e)
        }
        if (request === requestRef.current) setLoading(false)
    }, [useCase, page, limit, search, status, assignedTo])

    useEffect(() => {
        load()
    }, [load])

    return {
        data,
        loading,
        reload: load,
    }
}
